import { Box, Checkbox, Chip, Link, Popover, Stack, Typography } from '@mui/material';
import {
  GridRowId,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridValueFormatterParams
} from '@mui/x-data-grid-pro';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { getPoratlHost } from 'src/components/common/hooks/useUtil';
import CustomNoRowsOverlay from 'src/components/eTMF/search/CustomNoRowsOverlay';
import SearchHierarchy from 'src/components/layouts/DashboardLayout/SearchHierarchy';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { setUserDocPermissions } from 'src/store/User';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import DocumentViewerComponent from '../documentViewer/DocumentViewer';
import './tasks.scss';
import { CustomPagination } from 'src/util/DataTableFooter';
import { useGetStudiesQuery } from 'src/components/Services/Utils';

export interface IViewer {
  routeInfo?: (route: string) => void;
  onClicked?: boolean;
}

const TasksComponent = (props: IViewer) => {
  const [rows, setTaskList] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const [documentToDisplayTask, setDocumentToDisplayTask] = useState<any>();
  const [dataGridComponent, setDataGridComponent] = useState(true);
  const [rejectedBy, setRejectedBy] = React.useState('');
  const [rejectReason, setRejectReason] = React.useState('');
  const [rejectOn, setRejectOn] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [rowCount, setRowCount] = useState<number>(0);
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    id: false,
    isSelected: false
  });
  const [search, setSearch] = useState({
    Study: SearchHierarchyDetail?.data[0]?.Study,
    Country: SearchHierarchyDetail?.data[0]?.Country,
    Site: SearchHierarchyDetail?.data[0]?.Site
  });

  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const docService = new DocManagementService();
  const { checkPermission } = usePermissionWrapper();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const user: any = useAppSelector(state => state.user.user);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);
  const appName = 'ISF';
  const isfLevel = 'Site';
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  // Tasks Data Grid Columns
  const columns: GridColDef[] = [
    {
      field: 'task_title',
      headerName: 'Task',
      flex: 2,
      valueFormatter: params =>
        `=HYPERLINK("${getPoratlHost()}/?application=${appName}&key=${gethashedurikey(params)}", "${params.value}")`,
      renderCell: (params: any) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Typography
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              onMouseEnter={e => handlePopoverOpen(e, params.row)}
              onMouseLeave={handlePopoverClose}
              className="pwithRejectMark"
            >
              {checkPermission('view_document_details') ? (
                <Link onClick={() => gridFunc(params.row)}>{params.value!.toString()}</Link>
              ) : (
                params.value!.toString()
              )}
              {(params.row.action_name === 'Reject' || params.row.action_name === 'Review Feedback') && (
                <span className="rejectmark"></span>
              )}
            </Typography>
          </div>
        );
      }
    },
    {
      field: 'due_date',
      headerName: 'Due Date',
      flex: 1,
      minWidth: 120,
      type: 'date',
      valueFormatter: (params: GridValueFormatterParams) => {
        return preferedDateFormat(params.value);
      }
    },
    {
      field: 'priority',
      headerName: 'Priority',
      flex: 1,
      type: 'singleSelect',
      valueOptions: ['High', 'Medium', 'Low']
    },
    {
      field: 'isf_doc_status',
      headerName: 'Status',
      flex: 1,
      type: 'singleSelect',
      valueOptions: ['Uploaded', 'Ready for approval', 'Approved', 'Rejected', 'Expected']
    },
    {
      field: 'is_checked',
      headerName: 'Mark as Resolved',
      flex: 1,
      type: 'singleSelect',
      valueOptions: ['Yes', 'No'],
      renderCell: (params: any) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Checkbox
              checked={params?.row?.is_resolved}
              onChange={(event: any) => handleChange(event, params)}
              disabled={!checkPermission('tasks_mark_as_resolved') || params?.row?.is_resolved}
              inputProps={{
                title: 'Mark as Resolved'
              }}
            />
          </div>
        );
      }
    }
  ];

  useEffect(() => {
    window.scroll(0, 0);
    if (
      SearchHierarchyDetail?.data[0]?.Site != '' &&
      SearchHierarchyDetail?.data[0]?.Site != '--' &&
      SearchHierarchyDetail?.data[0]?.Site != undefined
    ) {
      if (pageSize === 10 || pageSize === 20 || pageSize === 30) {
        if (page * pageSize > rowCount - 1) {
          setPage(0);

          getAllTaskData(
            SearchHierarchyDetail?.data[0]?.Study,
            SearchHierarchyDetail?.data[0]?.Country,
            SearchHierarchyDetail?.data[0]?.Site,
            0,
            pageSize
          );
        } else
          getAllTaskData(
            SearchHierarchyDetail?.data[0]?.Study,
            SearchHierarchyDetail?.data[0]?.Country,
            SearchHierarchyDetail?.data[0]?.Site,
            page * pageSize,
            pageSize
          );
      }
    }
  }, [page, pageSize, SearchHierarchyDetail?.data[0]?.Site]);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      props.routeInfo && props.routeInfo(null as any);
    };
  }, []);

  useEffect(() => {
    if (dataGridComponent || props.onClicked) {
      props.routeInfo && props.routeInfo('');
      if (!dataGridComponent) {
        setDataGridComponent(true);
        getAllTaskData(
          SearchHierarchyDetail?.data[0]?.Study,
          SearchHierarchyDetail?.data[0]?.Country,
          SearchHierarchyDetail?.data[0]?.Site,
          0,
          pageSize
        );
      }
    } else {
      props.routeInfo && props.routeInfo('task');
    }
  }, [dataGridComponent, props.onClicked]);

  const gethashedurikey = (params: GridValueFormatterParams<any>) => {
    return rows.find((item: { id: GridRowId | undefined }) => item.id === params.id)?.hashed_uri_key;
  };

  /* Event Handling*/
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>, params: any) => {
    if (params.action_name === 'Reject' || params.action_name === 'Review Feedback') {
      setRejectedBy(params.rejected_by !== null ? params.rejected_by : params.commented_by);
      setRejectReason(params.reject_reason !== null ? params.reject_reason : params.feedback_comment);
      setRejectOn(params.rejected_on);
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>, params: any) => {
    if (event.target.checked) {
      const found = rows.find((item: any) => params?.row?.task_id === item.task_id);
      if (found && !found.is_resolved) {
        found.is_resolved = true;
        const data = {
          is_resolved: found.is_resolved,
          updated_by: user?.firstName ? user?.firstName + ' ' + user.lastName : user?.lastName,
          action_name: 'create task'
        };
        const res: any = await docService.updateTask(
          params?.row?.task_id,
          data,
          SearchHierarchyDetail?.data[0]?.Study,
          SearchHierarchyDetail?.data[0]?.Country,
          SearchHierarchyDetail?.data[0]?.Site,
          isfLevel,
          process.env.REACT_APP_NAME,
          'Task',
          params?.row?.task_title
        );
        if (res.data) {
          store.dispatch(setSnackbarMessage('Task is marked as resolved successfully.', 'success'));
        } else {
          found.is_resolved = false;
        }
        setTaskList(rows);
        getAllTaskData(
          SearchHierarchyDetail.data[0].Study,
          SearchHierarchyDetail.data[0].Country,
          SearchHierarchyDetail.data[0].Site,
          0,
          pageSize
        );
      }
    }
  };

  /* Event Handling*/

  const getAllTaskData = async (study: string, country: string, site: string, from: number, size: number) => {
    let count = 1;
    if (site && site !== '--') {
      const res: any = await docService.getAllTasks(
        study,
        country,
        site,
        isfLevel,
        process.env.REACT_APP_NAME,
        'Tasks',
        from,
        size
      );
      const taskArray: any = [];

      if (res.error) {
        setTaskList([]);
        setLoading(false);
      } else {
        setLoading(true);

        for (const data of res.data.selected_data) {
          setLoading(false);
          const taskObj = {
            task_id: data.task_id,
            task_title: data.task_title,
            due_date: data.due_date,
            document_id: data.document_id,
            priority: data.priority,
            isf_doc_status: data.isf_doc_status,
            is_resolved: data.is_resolved,
            is_checked: data.is_resolved === false ? 'No' : 'Yes',
            id: count++,
            isf_doc_country: data.isf_doc_country,
            isf_doc_site: data.isf_doc_site,
            isf_doc_study: data.isf_doc_study,
            study: study,
            country: country,
            site: site,
            isf_document_id: data.isf_document_id,
            isf_doc_version_number: data.isf_doc_version_number,
            hashed_uri_key: data.hashed_uri_key,
            reject_reason: data.reject_reason,
            rejected_on: data.rejected_on,
            rejected_by: data.rejected_by,
            commented_by: data.commented_by,
            feedback_comment: data.feedback_comment,
            action_name: data.action_name
          };
          taskArray.push(taskObj);
        }
      }
      setTaskList(taskArray);
      setSearch({ ...search, Study: study, Country: country, Site: site });
      setRowCount(res.data.record_count);
      setLoading(false);
    } else {
      setTaskList([]);
      setLoading(false);
    }
  };

  // Navigation to document viewer //
  const gridFunc = async (documentDetail: any) => {
    handlePopoverClose();
    const isf_document_id = documentDetail.isf_document_id;
    const entity = documentDetail.isf_document_name;
    const result = await docService.getVersionHistory(
      isf_document_id,
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Tasks',
      entity
    );
    const latestVersionDetails = result.data[0].document_version.isf_doc_version_number;
    const response: any = await docService.getMasterDocumentdetails(
      result.data[0]?.document_version.isf_doc_study,
      result.data[0]?.document_version.isf_document_id,
      result.data[0]?.document_version.isf_doc_version_number,
      result.data[0]?.document_version.isf_doc_country,
      result.data[0]?.document_version.isf_doc_site,
      result.data[0]?.document_version.isf_doc_level,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      result.data[0]?.document_version.isf_document_name
    );

    const dummyArr = [];
    dummyArr.push(response.data);
    const documentDataTotal = dummyArr.map((el: any) => {
      el.document_data.isf_doc_latest_version = latestVersionDetails;
      el.file_master.fmId = el.file_master.id;
      el.document_data.fileId = el.file_master.id;
      el.file_master.docFormat = el.file_master.isf_doc_type;
      el.document_data.hashed_uri_key = el.hashed_uri_key;
      el.document_data.task_Id = documentDetail.task_id;
      el.document_data.task_title = documentDetail.task_title;
      return el;
    });

    const comData = documentDataTotal.map(
      (respo: { document_data: any; file_master: any }) => [{ ...respo.file_master, ...respo.document_data }][0]
    );

    /**
     * Bharath
     */
    try {
      const response: any = await docService.getDocAccessPermissions(comData[0]);
      if (response.data != null && response.data.length > 0) {
        const docAccessPermissions: any = response.data.map((item: any) => item.permission);
        dispatch(setUserDocPermissions(docAccessPermissions));
        setDocumentToDisplayTask(comData[0]);
        setDocumentDetail(dispatch, [comData[0]]);

        setDataGridComponent(false);
      } else {
        updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
      }
    } catch (e: any) {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
    }
    /**
     * Bharath end
     */
  };

  const CustomToolbar = () => {
    const exportDateFormat = userPreferedDateFormat.includes('/')
      ? userPreferedDateFormat.replaceAll('/', '_')
      : userPreferedDateFormat.replaceAll('-', '_');
    const documentName = `ISF Tasks ` + moment(new Date()).format(`${exportDateFormat.toUpperCase()} hh_mm A`);
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarFilterButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} />
        {checkPermission('export_tasks_results') && (
          <GridToolbarExport
            csvOptions={{
              fileName: documentName,
              allColumns: false
            }}
          />
        )}
      </GridToolbarContainer>
    );
  };
  const { isLoading: getStudyLoad } = useGetStudiesQuery();

  return (
    <React.Fragment>
      {dataGridComponent ? (
        <div>
          <SearchHierarchy searchData={getAllTaskData} tab="TASKS" />
          {isDataAvailable !== null && isDataAvailable === false && !getStudyLoad ? (
            <div className="no-data-class">
              <h3>No Data access available!</h3>
            </div>
          ) : (
            <>
              <Box className="resultBox">
                <div style={{ height: '80vh', width: '100%' }}>
                  <DataGridPro
                    rows={rows}
                    columns={columns}
                    disableSelectionOnClick
                    rowCount={rowCount}
                    page={page}
                    onPageChange={newPage => setPage(newPage)}
                    pageSize={pageSize}
                    onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    paginationMode="server"
                    components={{
                      NoRowsOverlay: CustomNoRowsOverlay,
                      Toolbar: CustomToolbar,
                      Pagination: CustomPagination,
                      NoResultsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                          No rows
                        </Stack>
                      )
                    }}
                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel: any) => {
                      setColumnVisibilityModel(newModel);
                      const hideColumsArr: any = [];
                      for (const obj of columns) {
                        if (newModel[obj.field] === false) {
                          hideColumsArr.push(false);
                        } else {
                          hideColumsArr.push(true);
                        }
                      }
                    }}
                    className="tasks_DataGrid"
                    loading={loading}
                    getRowHeight={() => 'auto'}
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '2px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '6px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '16px' }
                    }}
                  />
                </div>
              </Box>
            </>
          )}
        </div>
      ) : (
        <div>
          {documentToDisplayTask && (
            <DocumentViewerComponent
              documentDetails={documentToDisplayTask}
              props={props}
              setDataGridComponent={setDataGridComponent}
            />
          )}
        </div>
      )}

      <>
        {/* {(params.row.action_name === 'Reject' || params.row.action_name === 'Review Feedback') && ( */}
        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: 'none'
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Box sx={{ flexGrow: 1, p: 2 }} className="rejectPopContent">
            <Chip label="Rejected" size="small" color="error" className="topRightChip" />
            <dl>
              <dt>Rejected By:</dt>
              <dd>{rejectedBy}</dd>
            </dl>
            <h4>
              Feedback Comment <span className="commented-date">on {preferedDateFormat(rejectOn)}</span>
            </h4>
            <p>{rejectReason}</p>
          </Box>
        </Popover>
        {/* )} */}
      </>
    </React.Fragment>
  );
};

export default React.memo(TasksComponent);
